import {request} from '@/helpers/apiClient'
import {SUB_CATEGORY_CONFIG} from '@/utils/constants/apiConfig/subCategoryConfig'

export const getSubCategoryList = async () => {
  return request(SUB_CATEGORY_CONFIG.SUB_CATEGORY_LIST)
} 